import {Routes} from "@angular/router";
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import { SOFTLINE_PERMISSION_PMS_MELDUNGEN } from "./meldungen.shared";

export const pmsMeldungRoutes: Routes = [
  {
    path: 'pmsmeldung',
    loadComponent: () => import('./components/meldungen.component'),
    children: [
      {
        path: 'query',
        loadComponent: () => import('./pages/query/query.component'),
      },
      {
        path: 'result',
        loadComponent: () => import('./pages/uebersicht/uebersicht.component'),
      },
      {
        path: '**',
        redirectTo: '/pmsmeldung/query'
      }
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_PMS_MELDUNGEN },
  }
];
